import { DamAssets } from './DamAssets';
import { route } from 'ziggy-js';

export class DamFilter {
    constructor() {
        this.filters = [];
        this.page = 1;
        this.draw = 1;
    }

    init() {
        this.actions();
    }

    actions() {
        document.querySelectorAll('*[data-role=tagFilter]').forEach(el => {
            el.querySelector('input[type=checkbox]').onchange = e => {
                if (e.target.checked) {
                    this.filters.push(e.target.value);
                }
                else {
                    this.filters.splice(this.filters.indexOf(e.target.value), 1);
                }

                this.filter();
                this.toggleFiltersButton();
            }
        });
    }

    filter() {
        this.draw++;

        document.querySelector('*[data-role=damAssetSearch]').value = '';

        const pageTitle = document.querySelector('h1').innerText;
        const currentOrder = new URL(window.location.href).searchParams.get('order');

        window.history.pushState(pageTitle, pageTitle, `${route('dam.index')}?draw=${this.draw}&page=${this.page}&tags=${this.filters.join(',')}&order=${currentOrder}`);

        const damAssets = new DamAssets();

        damAssets.assets();
    }

    toggleFiltersButton() {
        let filtersButton = document.querySelector('.dam-btn.dam-btn-filters'),
            filterCount = document.querySelector('.dam-btn.dam-btn-filters .filter-count');

        if (this.filters.length) {
            filtersButton.classList.add('active');
            filterCount.style.display = 'inline-block';
            document.querySelector('*[data-role=filterCount]').innerHTML = this.filters.length;
        } else {
            filtersButton.classList.remove('active')
            filterCount.style.display = 'none';
        }
    }
}
